'use strict'

import React from 'react';
import request from 'superagent';

import ProjectMenu from '../components/ProjectMenu.jsx';
import Layout from '../Layout.jsx';
import BusinessCaseSettings from './BusinessCaseSettings.jsx';
import SettingsForUsage from './SettingsForUsage.jsx';

class DefinitionSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state=this.loadSettings(props);
  }

  loadSettings(props) {
    return {
      edit:false,
      enabled:props.settings!==undefined && props.settings.show!==undefined ? props.settings.show : "definition",
      showBrief:props.settings!==undefined && props.settings.showBrief,
      showPID: props.settings!==undefined && props.settings.showPID
    };
  }

  componentWillReceiveProps(props) {
    this.setState(this.loadSettings(props));
  }

  selectBackground(event) {
    this.setState({enabled:"background", showBrief:false});
  }

  selectDefinition(event) {
    this.setState({enabled:"definition"});
  }

  enableBrief(event) {
    this.setState({showBrief:event.target.checked});
  }

  enablePID(event) {
    this.setState({showPID:event.target.checked});
  }

  changeSettings(event) {
    event.preventDefault();
    this.setState({edit:!this.state.edit});
  }

  cancelChange(event) {
    event.preventDefault();
    this.setState(this.loadSettings(this.props));
  }

  updateSettings(event) {
    event.preventDefault();
    this.setState({edit:false});
    if (this.props.onUpdate!==undefined) {
      this.props.onUpdate({
        area: "definition",
        definition: {
          show:this.state.enabled,
          showBrief:this.state.showBrief,
          showPID : this.state.showPID
        }
      });
    }
  }

  render() {
    let url=this.state.enabled==="definition" ? "/images/definition.png":"/images/background.png";
    return (
      <div style={{display:"flex",paddingBottom:20, }}>
        <div>
          <img src={url}/>
        </div>
        {this.state.edit ? (
        <div style={{paddingLeft:30}}>
          Use
          <div>
            <div>
              <input onChange={this.selectBackground.bind(this)} type="radio" name="definition" value="background" defaultChecked={this.state.enabled!=="definition"} id="background"/>
              <span> </span>
              <label htmlFor="background">Background only</label>
            </div>
            <div>
              <input onChange={this.selectDefinition.bind(this)} type="radio" name="definition" value="background" defaultChecked={this.state.enabled==="definition"} id="definition"/>
              <span> </span>
              <label htmlFor="definition">Definition</label>
            </div>
          </div>
          {this.state.enabled==="definition" ? (
            <div style={{paddingLeft:20, paddingTop:20}}>
              <b>Enable document generation</b><br/>
              <div>
                <input onClick={this.enableBrief.bind(this)} type="checkbox" defaultChecked={this.state.showBrief} id="brief"/> <label htmlFor="brief">Project Brief</label>
              </div>
              <div>
                <input onClick={this.enablePID.bind(this)} type="checkbox" defaultChecked={this.state.showPID} id="pid"/> <label htmlFor="pid">Project Initiation Document</label>
              </div>
            </div>
          ): null}
          <div style={{paddingTop:15}}>
            <input type="button" onClick={this.cancelChange.bind(this)} className="cancel" value="Cancel"/>
            <input onClick={this.updateSettings.bind(this)} type="submit" className="save" value="Update"/>
          </div>

        </div> ) : (
          <div style={{paddingLeft:30}}>
            <div>
              Use {this.state.enabled==="definition" ? "Definition" : "Background"}
              {this.state.enabled==="definition" && (this.state.showBrief || this.state.showPID) ? (
                <span>
                  <span> with enabled </span>
                  {[
                    this.state.showBrief ? "Project Brief" : undefined,
                    this.state.showPID ? "Project Initiation Document" : undefined
                  ].filter(item=>item!==undefined)
                  .map(item=>"\""+item+"\"")
                  .join(", ")}
                  <span>.</span>
                </span>
              ) : null}
            </div>
            <div style={{paddingTop:10}}>
              <i>Switch between <b>Background</b> and <b>Definition</b>. With <b>Definition</b> it is possible to enable "<b>Project Brief</b>" and <b>Project Initiation Document</b>.</i>
            </div>
            <div style={{paddingTop:15}}>
              <a href="#" onClick={this.changeSettings.bind(this)}>Change</a>
            </div>
          </div>
        )}
      </div>
    )
  }
}

class QualitySettings extends React.Component {
  render() {
    return (
      <SettingsForUsage
        {...this.props}
        image="/images/quality_s1.png"
        area="quality"
        label="Quality"
        help="Turn on or off use of Quality"
      />
    );
  }
}

export let Access={
  isBusinessCaseEnabled(settings) {
    let projectSettings=settings.project;
    let tenantSettings=settings.tenant;
    let disabledInTenant=tenantSettings!==undefined && tenantSettings.disableBusinessCase===true;
    let useBusinessCaseInProject=projectSettings!==undefined && projectSettings.useBusinessCase!==undefined && projectSettings.useBusinessCase;
    let businessCaseEnabled=projectSettings===undefined || projectSettings!==undefined && projectSettings.useBusinessCase===undefined && !disabledInTenant || useBusinessCaseInProject===true || useBusinessCaseInProject===undefined;
//    console.log("businessCase "+businessCaseEnabled+" (form "+JSON.stringify(settings)+", disabledInTenant: "+disabledInTenant+")");
    return businessCaseEnabled;
  }
}

export class ProjectSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state=this.loadSettings({project:props.project.settings,tenant:props.tenantSettings});
  }

  loadSettings(settings) {
    let projectSettings=settings.project;
    let tenantSettings=settings.tenant;
    return {
      definition: {
        show:projectSettings!==undefined && projectSettings.disabledDefinition ? "background" : "definition",
        showBrief:projectSettings!==undefined && projectSettings.reports!==undefined && projectSettings.reports.projectBrief,
        showPID: projectSettings!==undefined && projectSettings.reports!==undefined && projectSettings.reports.PID
      },
      businessCase: {
        enabled: Access.isBusinessCaseEnabled(settings)
      },
      quality: {
        enabled: projectSettings!==undefined && projectSettings.disabledQuality ? false : true
      }
    }
  }

  updateSettings(newSettings) {
    var commands=[];
    console.log("Update settings of "+newSettings.area+": "+JSON.stringify(newSettings));
    if (newSettings.area==="definition") {
      if (this.state.definition.show!==newSettings.definition.show && newSettings.definition.show==="background") {
        commands=commands.concat({type:"disableDefinition"});
      } else {
        if (newSettings.definition.show==="definition" && this.state.definition.show!=="definition") {
          commands=commands.concat({type:"enableDefinition"});
        }
        if (newSettings.definition.show==="definition" && newSettings.definition.showBrief && !this.state.definition.showBrief) {
          commands=commands.concat({type:"enableProjectBrief"});
        }
        if (newSettings.definition.show==="definition" && this.state.definition.show==="definition" && this.state.definition.showBrief && !newSettings.definition.showBrief) {
          commands=commands.concat({type:"disableProjectBrief"});
        }
        if (newSettings.definition.show==="definition" && newSettings.definition.showPID && !this.state.definition.showPID) {
          commands=commands.concat({type:"enableProjectInitiationDocument"});
        }
        if (newSettings.definition.show==="definition" && this.state.definition.show==="definition" && this.state.definition.showPID && !newSettings.definition.showPID) {
          commands=commands.concat({type:"disableProjectInitiationDocument"});
        }
      }
    } else if (newSettings.area==="businessCase") {
      if (this.state.businessCase.enabled!==newSettings.use) {
        commands=commands.concat({type:newSettings.use ? "enableBusinessCase" : "disableBusinessCase"});
      }
    } else if (newSettings.area==="quality") {
      if (this.state.quality.enabled!==newSettings.use) {
        commands=commands.concat({type:newSettings.use ? "enableQuality" : "disableQuality"});
      }
    } else {
      alert("Settings for "+newSettings.area+" is not supported.");
      this.setState(this.loadSettings(this.props.settings));
    }
    if (commands.length>0) {
      this.sendCommand({type:"updateProjectSettings", commands: commands, project:{id:this.props.project.id}})
        .then((settings)=>this.setState(this.loadSettings(settings)))
        .catch((details)=>{
          alert("Could not update settings. "+JSON.stringify(details));
          this.setState(this.loadSettings(this.props.settings));
        })
    }
  }

  //Modified from Change.js
  sendCommand(command) {
    return new Promise((resolve,reject)=>{
      request
        .post("/")
        .send(command)
        .end(function(error, response) {
          if (error===null && response.status===200) {
            var message=JSON.parse(response.text);
            if (message.status==="OK") {
              console.log("Success for command '"+command.type+"'");
              resolve(message.settings);
            } else {
              console.log("Error: "+message.message);
              reject(message.message);
            }
          } else {
            console.log("Error: "+error+", got "+response.status+" with message "+response.text);
            reject(response.text)
          }
        });
      })
  }


  render() {
    return (
      <div style={{display:"flex",padding:30, justifyContent:"center", fontFamily:"Lato"}}>
        <div style={{width:1016}}>
          <DefinitionSettings {...this.props} settings={this.state.definition} onUpdate={this.updateSettings.bind(this)}/>
          <BusinessCaseSettings {...this.props} settings={this.state.businessCase} onUpdate={this.updateSettings.bind(this)}/>
          <QualitySettings {...this.props} settings={this.state.quality} onUpdate={this.updateSettings.bind(this)}/>
        </div>
      </div>
    );
  }
}

export default class ProjectSettingsPage extends React.Component {
  render() {
    let menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <ProjectSettings {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/settings/ProjectSettings.jsx